import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ioteqDrawerComponent } from '@tools/components/drawer/drawer.component';

@NgModule({
    declarations: [
        ioteqDrawerComponent
    ],
    imports     : [
        CommonModule
    ],
    exports     : [
        ioteqDrawerComponent
    ]
})
export class ioteqDrawerModule
{
}
